import {
  IncentiveProgressResultTypenames,
  Query,
  QueryIncentiveProgressArgs,
} from '@varo/graphql-schema-types';
import IncentiveProgress from 'services/graphql/queries/Incentive/IncentiveProgress';
import { useQuery } from 'urql';

const useIncentiveProgress = (incentiveProgramId: string) => {
  const [{ data, fetching, error }, reexecuteQuery] = useQuery<
    Query,
    QueryIncentiveProgressArgs
  >({
    query: IncentiveProgress,
    variables: { input: { incentiveProgramId } },
    requestPolicy: 'cache-and-network',
  });

  const result = data?.incentiveProgress;
  const progress =
    result?.__typename ===
    IncentiveProgressResultTypenames.IncentiveProgressSuccess
      ? result.progress
      : undefined;
  const progressError =
    result?.__typename ===
    IncentiveProgressResultTypenames.IncentiveProgressError
      ? result
      : undefined;

  const refresh = () => {
    reexecuteQuery({ requestPolicy: 'network-only' });
  };

  return { progress, fetching, error, progressError, refresh };
};

export default useIncentiveProgress;
